/**
 * Utility for using assets across project
 * @params {path} path - reference for an asset based on the source chosen.
 * @params {Object} options - object for configuration.
 * @params {string} options.source - either 'kong'|'media-hub'. `kong` keeps
 *   the legacy direct CDN host; `media-hub` routes through the media-hub
 *   `kong` backend (IPX). There is no default yet so we can pick a better
 *   one in the future.
 */

const MEDIA_HUB_BASE = 'https://media-hub.quero.space'

export const asset = (path, { source } = {}) => {
  const slashedPath = (path?.startsWith('/')) ? path : `/${path}`

  const transformers = {
    kong: () => `https://kong.quero.com${slashedPath}`,
    // Routes through media-hub's `kong` backend (IPX). Legacy callers passed
    // paths like `/cdn/<file>` because the imageboss URL grammar required an
    // operation segment; `cdn` has no equivalent in IPX (modifiers live in
    // their own URL segment), so strip it to match the actual bucket key.
    'media-hub': () => {
      const path = slashedPath.startsWith('/cdn/') ? slashedPath.slice(4) : slashedPath
      return `${MEDIA_HUB_BASE}/img/_/kong${path}`
    },
  }

  if (typeof transformers[source] !== 'function') {
    // eslint-disable-next-line no-console
    console.warn(`[$asset]: The source "${source}" is not valid, fallbacking to pure path`)

    return path
  }

  const transformedPath = transformers[source]()

  return transformedPath
}

export default (_, inject) => {
  inject('asset', asset)
  inject('yCdn', asset)
}
